import axios from "axios"

const GetExpenser = async (route, hotelId, token, data,identifier = undefined) => {
    try {
        const response = await axios({
            method: "POST",
            url: route,
            headers: {
                "Authorization": `Bearer ${token}`
            },
            params: {
                hotelId,
                identifier:identifier
            },
            data: data
        })
        return response.data
    } catch (err) {
        console.log(err)
        return err.response ? (err.response.data ? err.response.data : {}) : {}
    }
}

export default GetExpenser